// extracted by mini-css-extract-plugin
export var arrow = "_c7-2";
export var label = "_c7-1";
export var reminder = "_c7-0";